<ui-page-container>
  <mat-card class="media-page-content">
    <mat-card-title>{{ 'Collezioni' | translate }}</mat-card-title>
    <mat-card-content>
      <ui-table
        [rowSelection]="'checkbox'"
        [fields]="fields"
        [pager]="pager$"
        [filters]="filters$ | async"
        [selected]="selectedItems?.length ? selectedItems : []"
        [reload]="reload$"
        [pagination]="false"
        [defaultSort]="defaultSort"
        (select)="selectHandler($event)"
        (rowAction)="manageRowActions($event)">
        <div tableActions>
          <app-entity-actions
            className="Role"
            [config]="{ showAddToCollection: false, showExport: false }"
            [selectedItemsCount]="selectedItems?.length"
            (add)="addHandler()"
            (delete)="deleteSelectedHandler()">
          </app-entity-actions>
        </div>
        <div tableFilters>
          <ui-filters
            [dialogFilters]="MobileFiltersComponent"
            (action)="applyFilterWithDelayHandler($event)">
            <app-collection-filters
              [filters]="filtersObj$ | async"
              #desktopFilter>
            </app-collection-filters>
          </ui-filters>
        </div>
      </ui-table>
    </mat-card-content>
  </mat-card>
</ui-page-container>
